
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@repo/ui/components/breadcrumb";
import { ChevronRight } from "@repo/ui/components/icon";
import { Link, useLocation } from "react-router";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type Crumb = { label: string; to?: string };

function titleize(str: string) {
  return str
    .split("-")
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join(" ");
}

function BreadcrumbPageCus({ title, items }: { title?: string; items?: Crumb[] }) {
  const { t } = useTranslation("common");
  const location = useLocation();

  const autoItems = useMemo<Crumb[]>(() => {
    const pathnames = location.pathname.split("/").filter(Boolean);
    const map: Record<string, string> = {
      "gioi-thieu": t("header.menu.about"),
      "tin-tuc": t("header.menu.news"),
      "san-pham": t("header.menu.products"),
      "mua-ban-mua-ban-can-ho": t("header.menu.products"),
      "tuyen-dung": t("header.menu.recruitment"),
      "lien-he": t("header.menu.contact"),
      "du-an": t("header.menu.projects"),
      "tim-kiem-du-an": t("header.menu.project_search"),
    };

    const crumbs: Crumb[] = [];
    pathnames.forEach((seg, idx) => {
      const url = "/" + pathnames.slice(0, idx + 1).join("/");
      const isLast = idx === pathnames.length - 1;
      const labelFromMap = map[seg];
      const label = isLast ? title || labelFromMap || titleize(seg) : labelFromMap || titleize(seg);

      // Special case: reading news /tin-tuc/:slug -> show Tin tức then current title/Chi tiết
      if (pathnames[0] === "tin-tuc" && idx === 0 && pathnames.length > 1) {
        crumbs.push({ label: map["tin-tuc"], to: "/tin-tuc" });
        return; // skip adding default for idx 0
      }

      crumbs.push({ label, to: isLast ? undefined : url });
    });

    // If path is /tin-tuc/:slug and we only added the first item above, add final crumb
    // if (pathnames.length > 1 && pathnames[0] === "tin-tuc") {
    //   crumbs.push({ label: title || "Chi tiết", to: undefined });
    // }

    return crumbs;
  }, [location.pathname, t, title]);

  const crumbs = items && items.length ? items : autoItems;

  return (
    <Breadcrumb className="py-5">
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild className="hover:text-black">
            <Link to="/">{t("header.menu.home")}</Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        {crumbs.map((c, i) => (
          <span key={`crumb-${i}`} className="contents">
            <BreadcrumbSeparator>
              <ChevronRight />
            </BreadcrumbSeparator>
            <BreadcrumbItem>
              {c.to ? (
                <BreadcrumbLink asChild className=" hover:text-black">
                  <Link to={c.to} >
                    {c.label}
                  </Link>
                </BreadcrumbLink>
              ) : (
                <BreadcrumbPage className="text-black">
                  {c.label}
                </BreadcrumbPage>
              )}
            </BreadcrumbItem>
          </span>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}

export default BreadcrumbPageCus;
